<template>
  <div class="fts-mobile-flow-diagram">
    <fts-spinner full-screen v-if="loading" />
    <fts-mobile-error :error-message="error" v-else-if="error" />
    <fts-flow-diagram :diagram-data="moduleData" v-else />
  </div>
</template>

<script>
import axios from 'axios';
import webAppConfig from '../commons/webApp.config';

import FTSMobileError from './FTSMobileError';
import FTSFlowDiagram from '../elements/FTSFlowDiagram';
import FTSSpinner from '../elements/FTSSpinner';

export default {
  components: {
    'fts-mobile-error': FTSMobileError,
    'fts-flow-diagram': FTSFlowDiagram,
    'fts-spinner': FTSSpinner
  },
  data: () => ({
    loading: false,
    error: null,
    moduleData: {},
  }),
  methods: {
    async loadDiagram() {
      try {
        this.loading = true;
        this.error = null;
        const res = await axios.get(`${webAppConfig.baseURL}/api/workspace/diagram/${this.$route.query.id}`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${this.$route.query.token}`,
            "tz": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "wsId": this.$route.query.wsId
          }
        });
        this.moduleData = res.data;
      } catch(err) {
        if (
          err.response &&
          (err.response.status === 400 || err.response.status === 401) &&
          err.response.data &&
          err.response.data.message
        ) {
          this.error = err.response.data.message;
        } else {
          this.error = "Page you trying to access is unavailable."
        }
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.token && this.$route.query.wsId) {
      this.loadDiagram();
    } else {
      this.error = "Page you trying to access is unavailable.\n Error: missing query parameters.";
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-mobile-flow-diagram {
  height: 100%;
}
</style>